import { Button, Select, Tag } from 'antd';
import palette from 'palette';
import styled from 'styled-components/macro';

export const StyledSelect = styled(Select)`
  width: 100%;
`;

export const StyledFilter = styled.div`
  display: flex;
  width: 100%;
  background: ${palette.white.w1};
  padding: 20px;

  .ant-picker-dropdown {
    z-index: 1000000;
  }
`;

export const StyledDateWrapper = styled.div`
  max-width: 375px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const StyledAddRemoveButton = styled(Button)`
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
  .remove {
    color: #ff4d4f;
  }
`;

export const StyledTag = styled(Tag)`
  margin-right: 3px;
`;

export const StyledSelectVehicleTypeItem = styled.div`
  display: flex;
  column-gap: 3px;
`;
